import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4516580"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box-title" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "box-details" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label fw-bold" }, "Request Sent: ", -1))
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label fw-bold" }, "Partner Response: ", -1))
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "box-details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'box': true,
      'cursor-pointer': _ctx.data.state === 'UPDATED',
    }),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToReviewSentRequest()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.index) + ": Partner Name:", 1),
        _createTextVNode(" " + _toDisplayString(_ctx.data.name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDate(_ctx.data.created_at)), 1)
      ]),
      _createElementVNode("span", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.data.response_at ? _ctx.formatDate(_ctx.data.response_at) : '-'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_base_button, { style: {width: 'fit-content'} }, {
        default: _withCtx(() => [
          _createTextVNode("Click: Action Required")
        ]),
        _: 1
      })
    ])
  ], 2))
}